import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import {AuthService} from '../services/auth.service';
import {environment} from '../../environments/environment';


export const AuthInterceptorSkipHeader = 'x-skip-auth-interceptor';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  /** Eén keer doorsturen, ook als tien verzoeken tegelijk een 401 krijgen. */
  private naarLogin = false;

  constructor(private authService: AuthService,
              private router: Router,
              private toaster: ToastrService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

    const onze = !request.headers.has(AuthInterceptorSkipHeader)
      && !!this.authService.token
      && (request.url.includes(environment.authUrl) || request.url.includes(environment.apiUrl));

    if (onze) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${this.authService.token}`,
        }
      });
    }

    return next.handle(request).pipe(
      catchError((fout: unknown) => {
        // Een verlopen sessie liet de console stilletjes leeglopen: elke lijst
        // leeg, alleen even een rood balkje "Could not load the clubs", en
        // verder geen aanwijzing (02-09-2026: geen clublijst op Monitoring,
        // dus ook geen studio-kaart en geen knop). Een token leeft zeven
        // dagen; daarna hoort de console je gewoon opnieuw te laten inloggen.
        //
        // Alleen voor verzoeken die ónze token droegen -- een fout wachtwoord
        // op /Account/Login is ook een 401, maar geen verlopen sessie.
        if (onze
          && fout instanceof HttpErrorResponse
          && fout.status === 401
          && !request.url.includes('/Account/Login')) {
          this.sessieVerlopen();
        }
        return throwError(() => fout);
      })
    );
  }

  private sessieVerlopen(): void {
    if (this.naarLogin) {
      return;
    }
    this.naarLogin = true;
    this.authService.logout();
    this.toaster.warning('Your session has expired — please log in again.');
    const terug = this.router.url;
    void this.router
      .navigate(['/login'], terug && !terug.startsWith('/login') ? { queryParams: { returnUrl: terug } } : {})
      .finally(() => { this.naarLogin = false; });
  }
}
